import { render, staticRenderFns } from "./UpdateBioData.vue?vue&type=template&id=2ea7c714"
import script from "./UpdateBioData.vue?vue&type=script&lang=js"
export * from "./UpdateBioData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports